import { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import {
  apiRequest,
  getRedirectUrl,
  markAuthenticated,
  setUserAccess,
  showKAlert,
} from '../helpers'
import { t } from '../locale'
import KButton from '../components/KButton'

export default function TwoFAVerify() {
  const { pending } = useParams<{ pending: string }>()
  const navigate = useNavigate()

  const [otp, setOtp] = useState('')
  const [recovery, setRecovery] = useState('')
  const [showRecovery, setShowRecovery] = useState(false)
  const recoveryRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    if (showRecovery) {
      const h = setTimeout(() => recoveryRef.current?.focus(), 0)
      return () => clearTimeout(h)
    }
  }, [showRecovery])

  async function submit() {
    apiRequest(`${process.env.REACT_APP_API_URL}/access/2fa/verify`, 'POST', {
      pendingToken: decodeURIComponent(pending || ''),
      otp: showRecovery ? undefined : otp || undefined,
      recovery: showRecovery ? recovery || undefined : undefined,
    }).then(r => {
      if (!r.userAccess) {
        showKAlert('danger', 'Kein Zugriff')
        return
      }

      sessionStorage.removeItem('accessToken')
      markAuthenticated()
      setUserAccess(r.userAccess)
      navigate(getRedirectUrl())
    })
  }

  return (
    <div className='container min-h-screen d-flex flex-col justify-content-center align-items-center'>
      <div className='col-12 col-md-5 col-lg-4 mt-4 px-4 mx-auto bg-white overflow-hidden text-center'>
        <Link to='https://ds-kyc.de' className='d-inline-block p-4'>
          <img src='/KYC_logo_black.png' alt='' style={{ maxHeight: '45px' }} />
        </Link>

        {/* centriran, višeredni tekst */}
        <p className='mb-4 small text-draft'>
          {t(
            'Bitte bestätigen Sie den Zugriff auf Ihr Konto, indem Sie den von Ihrer Authentifizierungsanwendung bereitgestellten Authentifizierungscode eingeben.'
          )}
        </p>

        {/* OTP polje (uvek vidljivo dok nije uključen recovery mod) */}
        {!showRecovery && (
          <div className='mt-4'>
            <label className='fw-medium smaller text-primary'>Code</label>
            <input
              className='border-primary bg-white rounded-md form-control w-100'
              value={otp}
              onChange={e => setOtp(e.target.value)}
              inputMode='numeric'
              autoComplete='one-time-code'
            />
          </div>
        )}
        {/* Recovery polje (vidljivo samo nakon klika na prvo dugme) */}
        {showRecovery && (
          <div className='mt-4'>
            <label className='fw-medium smaller text-primary'>
              {t('Recovery code') || 'Recovery code'}
            </label>
            <input
              ref={recoveryRef}
              className='border-primary bg-white rounded-md form-control w-100'
              value={recovery}
              onChange={e => setRecovery(e.target.value)}
              autoComplete='one-time-code'
            />
          </div>
        )}

        <div className='d-grid gap-3 mt-4'>
          <KButton
            className='btn btn-info btn-sm w-100 px-3 rounded-pill'
            variant='primary'
            disabled={showRecovery ? recovery.trim() === '' : otp.trim() === ''}
            onClick={submit}
            label={t('login')}
          ></KButton>
          <KButton
            className='btn btn-info btn-sm w-100 px-3 rounded-pill'
            variant='primary'
            onClick={() => setShowRecovery(prev => !prev)}
            label={t('recoveryCodes')}
          ></KButton>
        </div>
      </div>
    </div>
  )
}
